import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';


function Footer() {
  return (
    <div className="Footer-section">
      <h1>Here4U</h1>
      <p>hello@here4u.care</p>
      <div className="Footer-icon-row">
        <Link to="/ContactUs">
          <i className="fa-solid fa-envelope Footer-icons"></i>      
        </Link>
        <a href="https://www.instagram.com/here4u.care/" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram Footer-icons"></i></a>
      </div>
      <p>
        If you require immediate help,<br/>
        please contact 988 or 911
      </p>
      <p>
        <Link to="/PrivacyPolicy" className="Footer-no-decoration">Privacy Policy</Link>
      </p>
    </div>
  );
}

export default Footer;